import { getLocale, setLocale } from "@/utils/locale";

const state = {
  locale: getLocale(),
};

const mutations = {
  CHANGE_LOCALE: (state, locale) => {
    state.locale = locale;
  },
};

const actions = {
  changeLocale({ commit }, locale) {
    setLocale(locale);
    commit("CHANGE_LOCALE", locale);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
